import { TFeature } from '../../../../common/types/map';

type TFeatureOffer = TFeature['properties']['offers'][number];

function getIsSameOffer(offer: TFeatureOffer, selectedOffer: TFeatureOffer): boolean {
  const hasRealtyIds = offer.realtyId !== undefined && selectedOffer.realtyId !== undefined;

  if (hasRealtyIds) {
    return offer.realtyId === selectedOffer.realtyId;
  }

  const hasCianIds = offer.cianId !== undefined && selectedOffer.cianId !== undefined;

  return hasCianIds && offer.cianId === selectedOffer.cianId;
}

function getHasSelectedOffer(feature: TFeature, selectedFeature: TFeature): boolean {
  return feature.properties.offers.some(offer =>
    selectedFeature.properties.offers.some(selectedOffer => getIsSameOffer(offer, selectedOffer)),
  );
}

export function getFeatureWithSelectedState(feature: TFeature, selectedFeature: TFeature | null): TFeature {
  const isSelectedFeature = selectedFeature ? getHasSelectedOffer(feature, selectedFeature) : false;

  if (isSelectedFeature) {
    if (feature.properties.isActive) {
      return feature;
    }

    return {
      ...feature,
      properties: { ...feature.properties, isActive: true },
    };
  }

  if (!feature.properties.isActive) {
    return feature;
  }

  return {
    ...feature,
    properties: { ...feature.properties, isActive: false },
  };
}

export function getSelectedFeatureSignature(selectedFeature: TFeature | null): string {
  if (!selectedFeature) {
    return '';
  }

  return selectedFeature.properties.offers.map(({ realtyId, cianId }) => `${realtyId ?? ''}:${cianId ?? ''}`).join(',');
}
